import React from 'react';

const SupplierImages = ({ images }) => {
  if (!images || images.length === 0) return null;

  return (
    <div className="detail-card full-width">
      <div className="card-header">
        <h3>🖼️ Annotated Images ({images.length})</h3>
      </div>
      <div className="card-content">
        <div className="images-grid">
          {images.map((image, index) => (
            <div key={index} className="image-item">
              <img 
                src={image.blobUrl} 
                alt={image.fileName}
                className="detail-image"
              />
              <div className="image-info">
                <span className="image-name">{image.fileName}</span>
                <a 
                  href={image.blobUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="image-link"
                >
                  View Full Size →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupplierImages;
